/**
 * Renders a user's avatar photo if available, else initials with a hash-based color.
 * Usage:  <UserAvatar name="Bardol Cloupeau" avatarUrl={user.avatar_url} size={28} />
 */
import { useState } from "react";

const initials = (n) => (n || "?").trim().split(/\s+/).map(x => x[0]).join("").slice(0, 2).toUpperCase();

// Deterministic pastel color per user name.
const COLORS = [
  "#3B82F6","#8B5CF6","#EC4899","#F59E0B","#10B981","#06B6D4",
  "#EF4444","#F97316","#84CC16","#14B8A6","#6366F1","#D946EF",
];
const colorOf = (name) => {
  let h = 0;
  const s = String(name || "user");
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return COLORS[Math.abs(h) % COLORS.length];
};

export default function UserAvatar({ name, avatarUrl, size = 28, ring = false, className = "" }) {
  const [err, setErr] = useState(false);
  const ringCls = ring ? "ring-2 ring-white shadow-sm" : "";
  if (avatarUrl && !err) {
    return (
      <img
        src={avatarUrl}
        alt={name || "avatar"}
        onError={() => setErr(true)}
        loading="lazy"
        className={`rounded-full object-cover shrink-0 ${ringCls} ${className}`}
        style={{ width: size, height: size }}
        title={name}
        data-testid="user-avatar-img"
      />
    );
  }
  return (
    <div
      className={`rounded-full grid place-items-center text-white font-bold shrink-0 ${ringCls} ${className}`}
      style={{ width: size, height: size, background: colorOf(name), fontSize: Math.floor(size * 0.4) }}
      title={name}
      data-testid="user-avatar-fallback"
    >
      {initials(name)}
    </div>
  );
}
